const initialSizing = {
  list: {
    initial: {
      width: 'tw:w-full',
    },
    selected: {
      width: 'tw:w-1/2',
    },
    expanded: {
      width: 'tw:w-1/5',
    },
  },
  details: {
    initial: {
      width: 'tw:w-0',
    },
    selected: {
      width: 'tw:w-1/2',
    },
    expanded: {
      width: 'tw:w-4/5',
    },
  },
};

export default initialSizing;

export const INGESTION_EVENT_ROOT = 'INGESTION_EVENT_ROOT_';
